module.exports = __webpack_public_path__ + "static/scale-model-of-morton-theatre-in-athens-georgia-33b388b04baff3cfa400f70b146d4337.png";